import styled from "styled-components";
import ConsultRequest from "./ConsultRequest";
import { memberArray } from "../../../context/members/membercontext";
// 경영진 카드. type "1"은 대표(가로로 넓게), 나머지는 2열 카드
const BoardMemberCard = ({
  member: { name, rank, history, image, engTitle },
  type,
}) => {
  // 상담 요청 메일 주소·직함은 구성원 목록(membercontext)에서 같은 이름으로 찾는다
  const contact = memberArray.find((m) => m.name === name);
  return (
    <Div $feature={type === "1"}>
      <div className="photo">
        <img src={image} alt={name} />
      </div>
      <div className="desc">
        <EngTitleSpan>{engTitle}</EngTitleSpan>
        <NameSpan>{name}</NameSpan>
        <TitleSpan>
          {rank === "P"
            ? "회장 / 대표이사 / 관세사"
            : rank === "R"
            ? "대표관세사"
            : rank === "VP"
            ? "대표관세사"
            : rank === "CFO"
            ? "CFO / 전무"
            : null}
        </TitleSpan>
        <ul>
          {history?.map((x) => {
            return (
              <HistoryList key={x.content} bold={x.div === "現"}>
                {[x.div, x.content].join(" ")}
              </HistoryList>
            );
          })}
        </ul>
        {contact && <ConsultRequest members={[contact]} expert={contact} label="상담 요청" compact />}
      </div>
    </Div>
  );
};
export default BoardMemberCard;
const Div = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: ${({ $feature }) => ($feature ? "minmax(0, 0.9fr) minmax(0, 1.1fr)" : "minmax(0, 11rem) minmax(0, 1fr)")};
  border-radius: 1.25rem;
  border: 1px solid ${({ theme }) => theme.colors.line};
  background-color: white;
  box-shadow: ${({ theme }) => theme.shadow.sm};
  overflow: hidden;
  & > .photo {
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    min-height: ${({ $feature }) => ($feature ? "26rem" : "16rem")};
    background: radial-gradient(circle at 50% 110%, ${({ theme }) => theme.colors.accentSoft} 0, ${({ theme }) => theme.colors.monotone.extralight} 60%);
    & > img {
      width: ${({ $feature }) => ($feature ? "min(100%, 24rem)" : "100%")};
      max-height: ${({ $feature }) => ($feature ? "26rem" : "16rem")};
      object-fit: contain;
      object-position: bottom;
    }
  }
  & > .desc {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    padding: ${({ $feature }) => ($feature ? "clamp(1.75rem, 4vw, 3rem)" : "1.5rem 1.5rem 1.25rem")};
    & > ul {
      list-style: none;
      margin: 1.1rem 0 0;
      padding: 1.1rem 0 0;
      border-top: 1px solid ${({ theme }) => theme.colors.line};
      display: flex;
      flex-direction: column;
      gap: 0.3rem;
      font-size: ${({ $feature }) => ($feature ? "1.05rem" : "0.9rem")};
      /* 이력이 길어도 카드가 늘어나지 않도록 6줄 높이까지만 보이고 나머지는 스크롤(content-box라 상단 패딩은 max-height 밖) */
      line-height: 1.5;
      max-height: calc(6 * 1.5em + 5 * 0.3rem);
      overflow-y: auto;
      overscroll-behavior: contain;
      scrollbar-width: thin;
      scrollbar-color: ${({ theme }) => theme.colors.monotone.light} transparent;
      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 999px;
        background-color: ${({ theme }) => theme.colors.monotone.light};
      }
    }
  }
  @media (max-width: 575px) {
    grid-template-columns: minmax(0, 1fr);
    & > .photo {
      min-height: 14rem;
      & > img {
        max-height: 14rem;
        width: auto;
      }
    }
  }
`;
const EngTitleSpan = styled.span`
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.accent};
`;
const NameSpan = styled.span`
  font-size: 2rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colors.dark};
`;
const TitleSpan = styled.span`
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.foreground.dimmed};
`;
const HistoryList = styled.li`
  font-weight: ${(props) => (props.bold ? "600" : "400")};
  color: ${({ bold, theme }) => (bold ? theme.colors.dark : theme.colors.monotone.dark)};
  list-style: none;
`;
